import axios from "axios";
import store from "./../index"; // global store, used for loader etc.

export default {
    namespaced: true,
    state: {
        menus: [],
    },
    getters: {
        allMenus(state) {
            return state.menus;
        },
        // Example: get menus by type
        getMenusByType: (state) => (typeId) => {
            return state.menus.filter(menu => menu.typeId === typeId);
        },
    },
    mutations: {
        setMenus(state, payload) {
            state.menus = payload;
        },
    },
    actions: {
        async getHeaderMenus({ commit }) {
            store.commit("setLoader", true);
            try {
                const response = await axios.get("/header-menu");
                const menus = response.data; // adjust depending on backend shape
                commit("setMenus", menus);
                return menus;
            } catch (error) {
                console.error("Failed to fetch header menus", error);
                return false;
            } finally {
                store.commit("setLoader", false);
            }
        },
    },
};
